import { render, staticRenderFns } from "./GreetingMessageCpt.vue?vue&type=template&id=e149cb6a&scoped=true&"
import script from "./GreetingMessageCpt.vue?vue&type=script&lang=ts&"
export * from "./GreetingMessageCpt.vue?vue&type=script&lang=ts&"
import style0 from "./GreetingMessageCpt.vue?vue&type=style&index=0&id=e149cb6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e149cb6a",
  null
  
)

export default component.exports